function calculateWasherReviews(reviews) {
  const nonNullReviews = reviews.filter((r) => r.rateForWasher !== undefined && r.rateForWasher != null);
  return nonNullReviews.map((r) => r.rateForWasher).reduce((a, b) => a + b) / nonNullReviews.length;
}

exports.calculateWasherReviews = calculateWasherReviews;
